type AudienceDocSettingsRecord = {
  customerMetadata?: Record<string, unknown> | null;
};

export const getAudienceDocResidentResponsibleOnly = (
  record?: AudienceDocSettingsRecord | null,
) => record?.customerMetadata?.audienceDocResidentResponsibleOnly === true;

export const getAudienceDocShowAmounts = (
  record?: AudienceDocSettingsRecord | null,
) => record?.customerMetadata?.audienceDocShowAmounts !== false;

export const getAudienceDocIncludePhotos = (
  record?: AudienceDocSettingsRecord | null,
) => record?.customerMetadata?.audienceDocIncludePhotos !== false;

export const getAudienceDocPhotosOnly = (
  record?: AudienceDocSettingsRecord | null,
) => record?.customerMetadata?.audienceDocPhotosOnly === true;

/** Defaults on for copies of a change order until the copy saves an explicit choice. */
export const getAudienceDocShowOnlyChangeOrderChanges = (
  record?: AudienceDocSettingsRecord | null,
  parentScanType?: string | null,
) => {
  const savedValue = record?.customerMetadata?.audienceDocShowOnlyChangeOrderChanges;
  return typeof savedValue === 'boolean' ? savedValue : parentScanType === 'changeRequest';
};
